module.exports = __webpack_public_path__ + "media/bootstrap-icons/receipt-78e1f688.svg";